import React from 'react';
import PropTypes from 'prop-types';
import MultiSelect from '../MultiSelect';

/**
 * A list-page multi-select filter over a comma-joined filter value.
 *
 * Encodes the convention every one of these filters had re-implemented: the
 * filter holds a comma-separated list of selected values, an empty value (or
 * the legacy `'all'`) means "everything", and selecting everything sends
 * `null` rather than a list, because the backend treats an absent filter as
 * unfiltered. Getting that last part wrong sends a 50-item query string.
 */
export const MultiSelectFilter = ({ label, options, value, onChange, optionsWidth }) => {
  const allValues = options.map((option) => option.value);
  const selected = value && value !== 'all' ? value.split(',') : allValues;

  return (
    <MultiSelect
      label={label}
      options={options}
      value={selected}
      optionsStyle={optionsWidth ? { width: optionsWidth } : undefined}
      onChange={(values) => onChange(values.length === options.length ? null : values.join(','))}
      placeholder="All"
      showAllButton
      autoApply={false}
    />
  );
};

MultiSelectFilter.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
  ).isRequired,
  /** Comma-joined selection; empty or `'all'` means everything. */
  value: PropTypes.string,
  /** Called with the comma-joined selection, or `null` when all are selected. */
  onChange: PropTypes.func.isRequired,
  optionsWidth: PropTypes.number,
};

MultiSelectFilter.defaultProps = { value: '', optionsWidth: undefined };

export default MultiSelectFilter;
